import http from './http';

export default {
  all() {
    return http().get(`/v1/table_configurations`);
  },
  get(id) {
    return http().get(`/v1/table_configurations/${id}`);
  },
  create(data) {
    return http().post(`/v1/table_configurations`, data);
  },
  update(data) {
    return http().put(`/v1/table_configurations/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/table_configurations/${id}`);
  },
};
